import * as React from 'react';
import { H6Regular, Spinner, type StackProps, YStack } from 'smoothie';

import type { Guide } from '../../guidance/types/Guide';
import type { SearchResult } from '../../http/Fetcher';
import type { GuidanceSession } from '../types/GuidanceSessions';
import NoPastSessions from './NoPastSessions';
import PastSessionsList from './PastSessionsList';

interface PastSessionsProps extends StackProps {
    isLoading: boolean;
    sessions?: SearchResult<GuidanceSession>;
    guide?: Guide | null;
}

const PastSessions = ({
    isLoading,
    sessions,
    guide,
    ...props
}: PastSessionsProps) => {
    const displaySessions = (sessions?.results ?? []).filter(
        ({ startTime }) => {
            // quick hellos that are skipped in lieu of an alternate guidance process are
            // represented by sessions with a start time of 1970-01-01. do not show them to the member
            return new Date(startTime) > new Date(0);
        },
    );

    const hasDisplaySessions = displaySessions.length > 0;

    const sectionTitle = <H6Regular marginBottom={12}>History</H6Regular>;

    return hasDisplaySessions ? (
        <YStack {...props}>
            {sectionTitle}
            <PastSessionsList sessions={displaySessions} />
        </YStack>
    ) : (
        <YStack
            {...props}
            $sm={{
                flex: 1,
            }}
        >
            {sectionTitle}
            {isLoading ? (
                <Spinner marginVertical={36} />
            ) : (
                <NoPastSessions guide={guide} />
            )}
        </YStack>
    );
};

export default PastSessions;
